import React from 'react';
import styled from 'styled-components';
import { Tab } from '../../MoneyGuideProTypes';
import { LinkButton } from '../../../CommonComponents/Button';

export const TabList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
`;

export const TabItem = styled.li`
  padding: 0 16px;
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }
`;

export const TabButton = styled(LinkButton)`
  border-bottom: 3px solid transparent;
  border-radius: 0;
  color: #444444;
  font-size: 18px;
  font-weight: 600;
  height: 48px;
  text-transform: capitalize;

  ${props => (props.isActive ? 'border-color: #318DEA' : '')}
`;

interface Props {
  clientId: string;
  tabList: Tab[];
  tabId: number;
}

export const Tabs: React.FC<Props> = ({ clientId, tabList, tabId }) => {
  return (
    <TabList>
      {tabList.map(tab => (
        <TabItem key={tab.id}>
          <TabButton
            isActive={tab.id === tabId}
            onClick={() => {
              ADV.util.Router.go2('MoneyGuidePro', {
                clientId,
                tabSlug: tab.slug,
                tabId: tab.id,
              });
            }}
          >
            {tab.name}
          </TabButton>
        </TabItem>
      ))}
    </TabList>
  );
};
